import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Empregador } from '../../api.service';
import { BuscaPesquisavelComponent } from '../../shared/busca-pesquisavel.component';

@Component({
  selector: 'app-seletor-empregador-existente',
  standalone: true,
  imports: [BuscaPesquisavelComponent],
  templateUrl: './seletor-empregador-existente.component.html'
})
export class SeletorEmpregadorExistenteComponent {
  @Input() termo = '';
  @Input() empregadores: Empregador[] = [];
  @Input() rotuloEmpregador: (item: unknown) => string = () => '';
  @Input() detalheEmpregador: (item: unknown) => string = () => '';

  @Output() termoChange = new EventEmitter<string>();
  @Output() buscar = new EventEmitter<void>();
  @Output() selecionar = new EventEmitter<unknown>();
}
